import React from "react";
import { Routes, Route } from "react-router-dom";

import styles from "./PageContainer.module.css";
import MainPage from "../Page/MainPage/MainPage";
import AboutPage from "../Page/AboutPage/AboutPage";
import ProductPage from "../Page/ProductPage/ProductPage";
import PortfolioPage from "../Page/PortfolioPage/PortfolioPage";
import SupportPage from "../Page/SupportPage/SupportPage";

export default function PageContainer() {
  return (
    <div className={styles.PageContainer}>
      <Routes>
        <Route exact path="/" element={<MainPage />} />
        <Route path="/about/*" element={<AboutPage />} />
        <Route path="/product/*" element={<ProductPage />} />
        <Route path="/portfolio/*" element={<PortfolioPage />} />
        <Route path="/support/*" element={<SupportPage />} />
        <Route path="*" element />
      </Routes>
    </div>
  );
}
